import React, { useMemo } from 'react';
import './_newsItem.scss';
import ArrowBtn from '../../common/arrow_btn';
import { Link } from 'react-router-dom';

const ConditionalWrapper = ({
  condition,
  wrapperHref,
  wrapperLink,
  children,
}) => (condition ? wrapperHref(children) : wrapperLink(children));

const NewsItem = ({ externalLink, url, date, title, desc, imageUrl }) =>
  useMemo(() => {
    // function newsItemMouseMove(e) {
    //     const x =  e.clientX;
    //     const y =  e.clientY;
    //     const paralaxedImage = e.currentTarget.querySelector('.newsItemImage')
    //     paralaxedImage.style.transform = `translate(-${x/25}px, calc(-50% - ${y/25}px))`;
    // }

    const finalDate = date?.split('-').join('.').split('.').reverse().join('.');

    return (
      <ConditionalWrapper
        condition={externalLink}
        wrapperHref={(children) => (
          <a
            href={externalLink}
            target='_blank'
            rel='noopener noreferrer'
            className='newsItem'
          >
            {children}
          </a>
        )}
        wrapperLink={(children) => (
          <Link to={`/news/${url}`} className='newsItem'>
            {children}
          </Link>
        )}
      >
        <p>{finalDate}</p>
        <div className='newsItemBody'>
          <div className='newsItemImageBlock'>
            <div
              style={{ backgroundImage: `url('${imageUrl}')` }}
              className='newsItemImage'
            />
          </div>
          <div className='newsItemTitle'>
            <h4 dangerouslySetInnerHTML={{ __html: title }} />
            <ArrowBtn
              hideOnMobile
              buttonColor='black'
              url={externalLink || url}
              title='Read more'
            />
          </div>
          <div className='newsItemInfo'>
            <p dangerouslySetInnerHTML={{ __html: desc }} />
            <ArrowBtn
              hideOnDesktop
              buttonColor='black'
              url={externalLink || url}
              title='Read more'
            />
          </div>
        </div>
      </ConditionalWrapper>
    );
  }, [externalLink, url, date, title, desc, imageUrl]);

export default NewsItem;
